import { render, staticRenderFns } from "./SchedulingCalendarSelectButton.vue?vue&type=template&id=12b4fd78&"
import script from "./SchedulingCalendarSelectButton.vue?vue&type=script&lang=js&"
export * from "./SchedulingCalendarSelectButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
